export enum InvitationRecipientType {
    Student = 0,
    Parent = 1,
}
